import * as React from "react";
import PrimaryButtonWithIcon from "./Primary/ButtonWithIcon";
import SecondaryButtonWithIcon from "./Secondary/ButtonWithIcon";
import OutlineButtonWithIcon from "./Outline/ButtonWithIcon";
import TextButtonWithIcon from "./Text/ButtonWithIcon";
import TealButtonWithIcon from "./Teal/ButtonWithIcon";
import DownloadButtonWithIcon from "./Download/ButtonWithIcon";
import CardButton from "./Card/Button";
import { useEffect, useState } from "react";
import { TrackGAEvent } from "../../GoogleAnalytics";
import ExternalLinkButtonWithIcon from "./ExternalLinkButton/ButtonWithIcon";
import { launchVideoAsk } from "../../../utils/videoAsk";

interface Props {
  item: any;
  columns?: string;
  link?: string;
  target?: string;
  type?: "button" | "submit" | "reset";
  underline?: boolean
}

/**
 * Render Button Component
 * @param item - Objects of the button.
 */

const RenderButton = ({ item, underline }: Props) => {
  let buttonType = item?.fields?.ctaButtonVariety;
  buttonType = buttonType && buttonType.toLowerCase();
  const buttonIcon = item?.fields?.besideButtonIcon
  const componentName = item?.fields?.componentName
 // const enableLaunchVideoAsk = item?.fields?.enableLaunchVideoAsk === true
 const popupProvider =   item?.fields?.popupProvider
  let link = ''
  let target = '_self'

  if (item?.fields?.assetReference) {
    link = item?.fields?.assetReference?.fields?.file?.url
  } else {
    if (item?.fields?.buttonLinkExternal) {
      link = item?.fields?.buttonLinkExternal
    } else if (item?.fields?.buttonLink2) {
      link = '/'+item?.fields?.buttonLink2?.fields?.slug
    } else if (item?.fields?.buttonLink) {
      link = item?.fields?.buttonLink?.includes('/') ? item?.fields?.buttonLink : '/'+item?.fields?.buttonLink
    }
  }

  if (item?.fields?.assetReference || item?.fields?.buttonLinkExternal) {
    target =  '_blank'
  }

  if (!link.startsWith("/")) {
    target =  '_blank'
  }

  return (
    <>
      {buttonType === "externallinkbutton" && (
        <div key={item?.sys?.id}>
          <ExternalLinkButtonWithIcon
            variant="dark"
            name={item?.fields?.ctaText}
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
          />
        </div>
      )}
      {buttonType === "primarylight" && (
        <div key={item?.sys?.id}>
          <PrimaryButtonWithIcon
            name={item?.fields?.ctaText}
            variant="light"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
          // launchVideoAsk={enableLaunchVideoAsk}
          popupProvider={popupProvider}
          />
        </div>
      )}
      {buttonType === "primarydark" && (
        <div key={item?.sys?.id}>
          <PrimaryButtonWithIcon
            name={item?.fields?.ctaText}
            variant="dark"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
           // launchVideoAsk={enableLaunchVideoAsk}
            popupProvider={popupProvider}
          />
        </div>
      )}
      {buttonType === "secondary" && (
        <div key={item?.sys?.id}>
          <SecondaryButtonWithIcon
            name={item?.fields?.ctaText}
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
          />
        </div>
      )}
      {buttonType === "outlinelight" && (
        <div key={item?.sys?.id}>
          <OutlineButtonWithIcon
            name={item?.fields?.ctaText}
            variant="light"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
          />
        </div>
      )}
      {buttonType === "outlinedark" && (
        <div key={item?.sys?.id}>
          <OutlineButtonWithIcon
            name={item?.fields?.ctaText}
            variant="dark"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
          />
        </div>
      )}
      {buttonType === "textlight" && (
        <div key={item?.sys?.id}>
          <TextButtonWithIcon
            name={item?.fields?.ctaText}
            variant="light"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            underline={true}
            componentName={componentName}
            target={target}
          />
        </div>
      )}
      {buttonType === "textdark" && (
        <div key={item?.sys?.id}>
          <TextButtonWithIcon
            name={item?.fields?.ctaText}
            variant="dark"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            underline={true}
            componentName={componentName}
            target={target}
          />
        </div>
      )}
      {buttonType === "teal" && (
        <div key={item?.sys?.id}>
          <TealButtonWithIcon
            name={item?.fields?.ctaText}
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
          />
        </div>
      )}
      {buttonType === "downloadbutton" && (
        <div key={item?.sys?.id}>
          <DownloadButtonWithIcon
            variant="dark"
            name={item?.fields?.ctaText}
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
            underline={underline}
          />
        </div>
      )}
      {(buttonType === 'cardbutton-stacked' || buttonType === 'cardbutton-horizontal') &&
        <div key={item?.sys?.id}>
          <CardButton
            variant={item?.fields?.ctaButtonVariety?.toLowerCase() === 'cardbutton-stacked' ? 'stacked' : ''}
            name={item?.fields?.ctaText}
            link={link}
            iconUrl={item?.fields?.besideButtonIcon.fields.file.url}
            altText={item?.fields?.besideButtonIcon.fields.file.fileName}
            classes=""
            componentName={componentName}
            target={target}
          />
        </div>
      }
    </>
  );
};

const RenderButtonEvents = ({ item, link, target, type, underline }: Props) => {
  let buttonVariety = item?.fields?.ctaButtonVariety;
  buttonVariety = buttonVariety && buttonVariety.toLowerCase();
  const buttonIcon = item?.fields?.besideButtonIcon
  const componentName = item?.fields?.componentName
  let btnType: "button" | "submit" | "reset" = "button"
  btnType = type ?  type : "button"

  return (
    <>
      {buttonVariety === "externallinkbutton" && (
        <div key={item?.sys?.id}>
          <ExternalLinkButtonWithIcon
            variant="dark"
            name={item?.fields?.ctaText}
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
          />
        </div>
      )}
      {buttonVariety === "primarylight" && (
        <div key={item?.sys?.id}>
          <PrimaryButtonWithIcon
            name={item?.fields?.ctaText}
            variant="light"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
            buttonType={btnType}
          />
        </div>
      )}
      {buttonVariety === "primarydark" && (
        <div key={item?.sys?.id}>
          <PrimaryButtonWithIcon
            name={item?.fields?.ctaText}
            variant="dark"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
            buttonType={btnType}
          />
        </div>
      )}
      {buttonVariety === "secondary" && (
        <div key={item?.sys?.id}>
          <SecondaryButtonWithIcon
            name={item?.fields?.ctaText}
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
            buttonType={btnType}
          />
        </div>
      )}
      {buttonVariety === "outlinelight" && (
        <div key={item?.sys?.id}>
          <OutlineButtonWithIcon
            name={item?.fields?.ctaText}
            variant="light"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
            buttonType={btnType}
          />
        </div>
      )}
      {buttonVariety === "outlinedark" && (
        <div key={item?.sys?.id}>
          <OutlineButtonWithIcon
            name={item?.fields?.ctaText}
            variant="dark"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
            buttonType={btnType}
          />
        </div>
      )}
      {buttonVariety === "textlight" && (
        <div key={item?.sys?.id}>
          <TextButtonWithIcon
            name={item?.fields?.ctaText}
            variant="light"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            underline={underline}
            componentName={componentName}
            target={target}
            buttonType={btnType}
          />
        </div>
      )}
      {buttonVariety === "textdark" && (
        <div key={item?.sys?.id}>
          <TextButtonWithIcon
            name={item?.fields?.ctaText}
            variant="dark"
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            underline={underline}
            componentName={componentName}
            target={target}
            buttonType={btnType}
          />
        </div>
      )}
      {buttonVariety === "teal" && (
        <div key={item?.sys?.id}>
          <TealButtonWithIcon
            name={item?.fields?.ctaText}
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
            buttonType={btnType}
          />
        </div>
      )}
      {buttonVariety === "downloadbutton" && (
        <div key={item?.sys?.id}>
          <DownloadButtonWithIcon
            variant="dark"
            name={item?.fields?.ctaText}
            link={link}
            classes=""
            buttonIcon={buttonIcon}
            componentName={componentName}
            target={target}
          />
        </div>
      )}
      {(buttonVariety === 'cardbutton-stacked' || buttonVariety === 'cardbutton-horizontal') &&
        <div key={item?.sys?.id}>
          <CardButton
            variant={item?.fields?.ctaButtonVariety?.toLowerCase() === 'cardbutton-stacked' ? 'stacked' : ''}
            name={item?.fields?.ctaText}
            link={link}
            iconUrl={item?.fields?.besideButtonIcon.fields.file.url}
            altText={item?.fields?.besideButtonIcon.fields.file.fileName}
            classes=""
            componentName={componentName}
            target={target}
          />
        </div>
      }
    </>
  );
};

const RenderCardButton = ({ item, columns }: Props) => {
  return (
    <div className="flex flex-wrap gap-16">
    {item?.map((button) => (
      <div
        key={button?.sys?.id}
        className={`w-full md:w-[48.5%] ${columns} md:max-w-[50%]`}
      >
        <CardButton
          variant={button?.fields?.ctaButtonVariety?.toLowerCase() === 'cardbutton-stacked' ? 'stacked' : ''}
          name={button?.fields?.ctaText}
          link={button?.fields?.buttonLinkExternal}
          iconUrl={button?.fields?.besideButtonIcon.fields.file.url}
          altText={button?.fields?.besideButtonIcon.fields.file.fileName}
          classes=""
        />
      </div>
    ))}
  </div>
  );
};


const ButtonWrapper = (content: any, columns) => {
  const [flexDirection, setFlexDirection] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    if(!content) return
    let filterBtn = []
    if (content?.content?.features) {
      setFlexDirection(content?.content?.features?.filter((item) => item?.fields?.ctaButtonVariety?.toLowerCase().includes('cardbutton')).length === 0)
      filterBtn = content?.content?.features?.filter((btn) => btn?.sys?.contentType?.sys?.id === 'ctaButtonComponent')
    } else if (content?.content?.button) {
      setFlexDirection(content?.content?.button?.filter((item) => item?.fields?.ctaButtonVariety?.toLowerCase().includes('cardbutton')).length === 0)
      filterBtn = content?.content?.button?.filter((btn) => btn?.sys?.contentType?.sys?.id === 'ctaButtonComponent')
    }
    setData(filterBtn)
  }, [content])

  return (
    <div className={`flex ${flexDirection ? 'flex-col' : 'flex-wrap'} gap-16 ${data.length > 0 ? '' : ''}`}>
      {data?.map((item, index) => (
        <div key={`${item?.fields?.ctaButtonVariety}-${index}`} data-testid="ctaTestBtn" className={`${(item?.fields?.ctaButtonVariety?.toLowerCase().includes('cardbutton')) ? `w-full ${columns} sm:w-[calc(50%-12px)] lg:w-[calc(33.33%-16px)]` : ''}`}>
          <RenderButton item={item} />
        </div>
      ))}
    </div>
  )
}

const buttonLinkClick = (e: React.MouseEvent<HTMLButtonElement>, name: string, link: string, target: string, componentName?: string, popupProvider?: string, onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void ) => {
  e.preventDefault()
  e.stopPropagation()

  TrackGAEvent('button_click', name, link, componentName)

if (popupProvider === 'ESSSuper Digital Assistant (VideoAsk)') {
  if (!link?.trim()) {
    console.error(
      'VideoAsk popup selected but External URL is not configured.'
    )
    return
  }

  launchVideoAsk(link)
  return
}

if (!link?.trim()) {
  console.warn('External URL is not configured.')
  return
}

if (link?.includes('scroll#')) {
  const id = link.replace('scroll#', '')
  const targetElement = document.getElementById(id)
  targetElement?.classList.remove('hidden')
  const top = targetElement?.offsetTop
  window.scrollTo({ top: top, behavior: 'smooth' })
} else {
  if (target === "_blank") {
    window.open(link, target)
  } else {
    window.location.href = link
  }
}

if (onClick) {
  onClick(e)
}

}




// const buttonLinkClick = (e: React.MouseEvent<HTMLButtonElement>, name: string, link: string, target: string, componentName?: string, launchVideoAskFlag?: boolean, onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void ) => {
//   e.preventDefault()
//   e.stopPropagation()

//   TrackGAEvent('button_click', name, link, componentName)

// if (launchVideoAskFlag) {
//   e.preventDefault()
//   e.stopPropagation()

//   launchVideoAsk()

//   return
// }

//   if (link?.includes('scroll#')) {
//     const id = link.replace('scroll#', '')
//     const targetElement = document.getElementById(id)
//     targetElement?.classList.remove('hidden')
//     const top = targetElement?.offsetTop
//     window.scrollTo({top: top, behavior: 'smooth'})
//   } else {
//     if (target === "_blank") {
//       window.open(link, target)
//     } else {
//       window.location.href = link
//     }
//   }
//   if(onClick) {
//     onClick(e)
//   }
// }

export { RenderCardButton, RenderButton, ButtonWrapper, buttonLinkClick, RenderButtonEvents };
